import type { components } from '@/api/schema'

// The shape of a visit being COMPOSED, before it is a Visit. Row 0 carries the
// start date; rows 1+ carry the re-treatment interval. Quick capture no longer
// renders these as an editor (the type's program is stated in one line, and row
// surgery is a job-page act) — but they still travel as the visits[] payload:
// the server never reads template_steps, so a program only exists if the client
// sends it.
export type VisitRow = {
  name: string
  // work (a treatment — the default) or evaluation (the sales look-see the
  // intake books before any quote exists).
  kind: 'work' | 'evaluation'
  scheduledAt: string
  durationMinutes: number | undefined
  intervalMinDays: number | undefined
  intervalMaxDays: number | undefined
  flexible: boolean
}

export const blankVisitRow = (): VisitRow => ({
  name: '',
  kind: 'work',
  scheduledAt: '',
  durationMinutes: 120,
  intervalMinDays: 14,
  intervalMaxDays: 21,
  flexible: false,
})

// A row seeded from a job type's template step. Template steps are always
// treatments — the evaluation precedes the template being known.
export const rowFromStep = (step: components['schemas']['TemplateStepResource']): VisitRow => ({
  name: step.attributes.name ?? '',
  kind: 'work',
  scheduledAt: '',
  durationMinutes: step.attributes.default_duration_minutes ?? undefined,
  intervalMinDays: step.attributes.interval_min_days ?? undefined,
  intervalMaxDays: step.attributes.interval_max_days ?? undefined,
  flexible: false,
})
